export const KUBERNETES_DATA = {
  intelData: [
    {
      cpu: "2",
      memory: "4GB",
      storage: "80GB",
      nodes: "3",
      monthlyPrice: 25,
    },
    {
      cpu: "4",
      memory: "8GB",
      storage: "160GB",
      monthlyPrice: 50,
    },
    {
      cpu: "8",
      memory: "16GB",
      storage: "320GB",
      monthlyPrice: 100,
    },
    {
      cpu: "16",
      memory: "32GB",
      storage: "640GB",
      monthlyPrice: 200,
    },
    {
      cpu: "32",
      memory: "64GB",
      storage: "1280GB",
      monthlyPrice: 400,
    },
    {
      cpu: "48",
      memory: "96GB",
      storage: "1920GB",
      monthlyPrice: 600,
    },
  ],
  amData: [
    {
      cpu: "1",
      memory: "4GB",
      storage: "30GB",
      monthlyPrice: 30,
    },
    {
      cpu: "2",
      memory: "8GB",
      storage: "50GB",
      monthlyPrice: 60,
    },
    {
      cpu: "4",
      memory: "16GB",
      storage: "80GB",
      monthlyPrice: 120,
    },
    {
      cpu: "8",
      memory: "32GB",
      storage: "160GB",
      monthlyPrice: 240,
    },
    {
      cpu: "16",
      memory: "64GB",
      storage: "320GB",
      monthlyPrice: 480,
    },
    {
      cpu: "24",
      memory: "96GB",
      storage: "480GB",
      monthlyPrice: 720,
    },
    {
      cpu: "32",
      memory: "128GB",
      storage: "640GB",
      monthlyPrice: 960,
    },
    {
      cpu: "40",
      memory: "160GB",
      storage: "768GB",
      monthlyPrice: 1200,
    },
    {
      cpu: "64",
      memory: "192GB",
      storage: "960GB",
      monthlyPrice: 1920,
    },
    {
      cpu: "96",
      memory: "256GB",
      storage: "1280GB",
      monthlyPrice: 3840,
    },
  ],
};

export const SECTION_CONSTANTS = {
  heading: "Kubernetes Pricing",
  footer: {
    btnText: "Get a Detailed Estimate",
  },
};
